<script setup lang="ts">
import { makeLinkToSettingsRef } from "~/router/common";
import type { PropertyAnyUser, PropertyConfig } from "~/shared/types";

defineProps<{
  property: PropertyAnyUser;
  propertyConfig: PropertyConfig;
}>();

const typesLink = makeLinkToSettingsRef("types");
</script>

<template>
  <div class="select-none text-sm/relaxed text-lt">
    <!-- prettier-ignore -->
    <p>
      Configure specific workflows with types in the
      <RouterLink :to="typesLink" class="underline text-vlt">dedicated types settings page</RouterLink>.
    </p>
  </div>
</template>
